import React from 'react'
import Image from '../../pics'; 
function poster() {
  return (
    <div>
        <div className="uk-section">
            <div className="uk-container">
                <div className="uk-card uk-text-left uk-grid-collapse uk-margin" data-uk-grid>
                    <div className="uk-width-1-4@m align-items-center">
                        <div className="uk-card">
                            <img src={Image.CAREER_POSTER} alt='domestic courier' width="100%" height="100%"/>
                            {/* <video src={VIDEO_PATH} width="100%" height="200px" loop playsinline controls data-uk-video="autoplay: inview"></video> */}
                        </div>
                    </div>
                    <div className="uk-width-3-4@m">
                        <div className="uk-card uk-card-body">
                            <h4 className="text-primary uk-text-bold">
                                Wanted: Courier Pick-Up & Delivery Associate!
                            </h4>
                            <p className='uk-text-justify text-secondary'>
                            As an associate, you'll deliver packages safely and promptly, provide excellent service, maintain accurate records, and handle packages with care. Adhering to traffic laws, promptly reporting issues, and using equipment responsibly are crucial for smooth operations.
                            </p>
                            <p className='text-primary'>
                                Become a part of our fast-paced, innovative courier company. Your next exciting career starts here!
                            </p>
                            <div className="uk-text-left">
                            <a href='mailto:contactus@mystratos.co.in'>
                                <button>
                                    Apply Now
                                </button>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default poster